(function (){
    'use strict';

    angular
        .module('services')
        .service('HuddleService', HuddleService);

    HuddleService.$inject = ['$http', 'API_BASE'];

    function HuddleService ($http, API_BASE) {
        var service = this;

        service.getByFilterCareerAdvisors                   = getByFilterCareerAdvisors;
        service.getByFilterCareerAdvisorsCsv                = getByFilterCareerAdvisorsCsv;
        service.deleteCareerAdvisor                         = deleteCareerAdvisor;

        /* STUDENTS */
        function getByFilterCareerAdvisors(query) {
            return $http.get(API_BASE + '/huddle/career-advisors', {params: query});
        }

        function getByFilterCareerAdvisorsCsv(query) {
            return $http.get(API_BASE + '/huddle/career-advisors/csv', {params: query});
        }

        function deleteCareerAdvisor(query) {
            return $http.get(API_BASE + '/huddle/delete', {params: query});
        }
    }
})();